import { createSelector } from 'reselect';
import { updateQuickLookModalSelector } from 'selectors/testTarget/offers/updateQuickLookModal/updateQuickLookModalSelector';

const showSelector = createSelector(updateQuickLookModalSelector, updateQuickLookModal => !!updateQuickLookModal.show);

export { showSelector };
